import { useState, useEffect } from 'react';
import { getStickyATCElement } from '../utils/assistant-utils';

export function useStickyElementOffset() {
  const [offsetMargin, setOffsetMargin] = useState(0);

  const getOffset = () => {
    const stickyATCElement = getStickyATCElement();
    return stickyATCElement && !stickyATCElement.classList.contains('sui-hidden')
      ? stickyATCElement.offsetHeight : 0;
  };

  useEffect(() => {
    const targetNode = document.querySelector('#root [data-fusion-section="F"]');
    const callback = () => setOffsetMargin(getOffset());
    const observer = new MutationObserver(callback);

    if (targetNode) {
      observer.observe(targetNode, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    return () => observer.disconnect();
  }, []);

  return offsetMargin;
}